import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Link, NavLink } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import { Context } from "../../context";
import classes from "./Project.module.css";

const ProjectBreadcrumb = ({ title }) => {
  const { debug, lang } = useContext(Context);

  return (
    <>
      <p className={classes.breadcrumb}>
        <NavLink
          to="/project"
          className="nav-link smooth-scroll text-underline"
        >
          <button className={`${classes.allProjectButton} btn btn-sm`}>
            {lang === "en" && <>All projects</>}
            {lang === "it" && <>Progetti</>}
          </button>
        </NavLink>
        &nbsp; &gt; {title}
      </p>
    </>
  );
};

export default ProjectBreadcrumb;
